import { Injectable } from '@angular/core';
import { LogLevel } from './logLevel.model';
@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  info(msg: unknown, ...optionalParams: unknown[]): void {
    this.logWith(LogLevel.Info, msg, ...optionalParams);
  }
  warn(msg: unknown, ...optionalParams: unknown[]): void {
    this.logWith(LogLevel.Warn, msg, ...optionalParams);
  }
  error(msg: unknown, ...optionalParams: unknown[]): void {
    this.logWith(LogLevel.Error, msg, ...optionalParams);
  }

  private stringifyMsg(msg: unknown): string {
    switch (typeof msg) {
      case 'string':
        return msg;
      case 'object':
        if ((msg as Record<string, unknown>).message) {
          return (msg as Record<string, unknown>).message as string;
        } else {
          return JSON.stringify(msg, null, 2);
        }
      default:
        return JSON.stringify(msg, null, 2);
    }
  }

  private logWith(level: LogLevel, msg: unknown, ...optionalParams: unknown[]): void {
    const message = this.stringifyMsg(msg);

    if (!message) {
      console.trace('%c' + 'Error with empty message', 'color: #DC143C', ...optionalParams);
    } else {

      if (level <= LogLevel.Error) {
        switch (level) {
          case LogLevel.None:
            return console.log(message, optionalParams);
          case LogLevel.Info:
            return console.info('%c' + message, 'color: #6495ED', ...optionalParams);
          case LogLevel.Warn:
            return console.warn('%c' + message, 'color: #FF8C00', ...optionalParams);
          case LogLevel.Error:
            return console.error('%c' + message, 'color: #DC143C', ...optionalParams);
          default:
            console.debug(message);
        }
      }
    }
  }
}